import { DeviceStatusPipeModule } from './../../../pipes/device-status-pipe.module';
import { SinControllerModule } from './../../../../patient/sin-controller/sin-controller.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DeviceStatusComponent } from './../status/device-status.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../../../../shared/translate/translate.module';

@NgModule({
  declarations: [
    DeviceStatusComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    DeviceStatusPipeModule,
    ReactiveFormsModule,
    SinControllerModule
  ],
  exports: [
    DeviceStatusComponent
  ]
})
export class DeviceStatusModule { }
